import { Component, EventEmitter, Input, Output } from '@angular/core'
import { Content, Device, User } from '../../models'
import { DeviceService } from './../../services/device.service'

@Component({
  selector: 'manage-devices',
  templateUrl: './manage-devices.modal.html'
})
export class ManageDevicesModal {
  @Input() public content: Content
  @Input() public user: User
  @Input() public allDevices: Device[]
  @Output()
  public allDevicesChange: EventEmitter<Device[]> = new EventEmitter()
  @Output() public userChange: EventEmitter<User> = new EventEmitter()
  @Output() public contentChange: EventEmitter<Content> = new EventEmitter()

  public deviceSearchInput
  public deviceSearchInput2

  constructor(private _deviceService: DeviceService) { }

  public removeDeviceFromUser(device: Device) {
    this._deviceService.removeDeviceFromUser(this.user._id, device._id).subscribe(
      (data) => {
        this.allDevices.unshift(device)
        this.user.myDevices = this.user.myDevices.filter(function (dev) {
          return dev._id !== device._id
        })
        this.updateParent()
      },
      (error) => { }
    )
  }

  public addDeviceToUser(device: Device) {
    this._deviceService.addDeviceToUser(this.user._id, device._id).subscribe(
      (data) => {
        this.user.myDevices.unshift(device)
        this.allDevices = this.allDevices.filter(function (dev) {
          return dev._id !== device._id
        })
        this.updateParent()
      },
      (error) => { }
    )
  }

  public subscribeContentToDevice(device: Device) {
    this._deviceService
      .subscribeContentToDevice(this.content._id, device._id)
      .subscribe(
        (data) => {
          this.content.subscribedDevices.unshift(device)
          this.allDevices = this.allDevices.filter(function (dev) {
            return dev._id !== device._id
          })
          this.updateParent()
        },
        (error) => { }
      )
  }
  public unsubscribeContentToDevice(device: Device) {
    this._deviceService
      .unsubscribeContentToDevice(this.content._id, device._id)
      .subscribe(
        (data) => {
          this.allDevices.unshift(device)
          this.content.subscribedDevices = this.content.subscribedDevices.filter(
            function (dev) {
              return dev._id !== device._id
            }
          )
          this.updateParent()
        },
        (error) => { }
      )
  }

  private updateParent() {
    this.allDevicesChange.emit(this.allDevices)
    this.userChange.emit(this.user)
    this.contentChange.emit(this.content)
  }
}
